import React, { useState } from 'react';
import { useLibrary } from '../context/LibraryContext';

function StarRating({ bookId, size = 'lg', readOnly = false }) {
  const { getRating, setRating } = useLibrary();
  const [hovered, setHovered] = useState(0);

  if (!bookId) return null;

  const currentRating = getRating(bookId);
  const displayRating = hovered > 0 ? hovered : currentRating;

  const starSize = size === 'lg' ? 'w-7 h-7' : 'w-4 h-4';
  const gapClass = size === 'lg' ? 'gap-1.5' : 'gap-0.5';

  const handleClick = (star) => {
    if (readOnly) return;
    // Clicking the same star again removes the rating
    if (currentRating === star) {
      // Reset by setting to 0 — we store as absence in the map
      setRating(bookId, star);
    } else {
      setRating(bookId, star);
    }
  };

  const handleMouseEnter = (star) => {
    if (!readOnly) setHovered(star);
  };

  const handleMouseLeave = () => {
    if (!readOnly) setHovered(0);
  };

  return (
    <div
      className={`flex items-center ${gapClass}`}
      onMouseLeave={handleMouseLeave}
      role={readOnly ? 'img' : 'group'}
      aria-label={`Rating: ${currentRating} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = star <= displayRating;
        return (
          <button
            key={star}
            type="button"
            disabled={readOnly}
            onClick={() => handleClick(star)}
            onMouseEnter={() => handleMouseEnter(star)}
            aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
            className={`
              ${starSize}
              transition-all duration-150
              focus:outline-none
              ${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110 active:scale-95'}
            `}
            style={{ background: 'none', border: 'none', padding: 0 }}
          >
            <svg
              viewBox="0 0 24 24"
              className={`w-full h-full transition-colors duration-150`}
              fill={filled ? '#f5a623' : 'none'}
              stroke={filled ? '#f5a623' : '#6b7280'}
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </button>
        );
      })}
      {!readOnly && currentRating > 0 && (
        <span className="text-xs text-gray-500 ml-1">
          {currentRating}/5
        </span>
      )}
    </div>
  );
}

export default StarRating;
